// login action types
export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

// profile action types
export const PROFILE_STARTED = 'PROFILE_STARTED';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILED =  'PROFILE_FAILED';

// register action types
export const REGISTRATION_STARTED = 'REGISTRATION_STARTED';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAILED  = 'REGISTRATION_FAILED'; 

// logout
export const LOGOUT = 'LOGOUT';;

// profile update
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const DELETE_PROFILE_FAIL = 'DELETE_PROFILE_FAIL';
